import React from 'react';
import { useAppData } from '../AppContext';
import { DEF_STATS } from '../store';
import './StatsBar.css';

const StatsBar = () => {
  const { stats } = useAppData();
  const items = stats || DEF_STATS;
  return (
    <section className="stats-bar">
      {items.map((stat, i) => (
        <div key={stat.id || i} className="stat-item" data-aos="fade-up" data-aos-delay={i * 80}>
          <span className="stat-value">{stat.value}</span>
          <span className="stat-label">{stat.label}</span>
        </div>
      ))}
    </section>
  );
};

export default StatsBar;
